import { useMeQuery } from '../../../apiHooks/useMeQuery';

/**
 * Hook to get the current user's department information.
 * Returns the department from the current user's data.
 */
export const useCurrentUserDepartment = (): string | null => {
    const { data: meData } = useMeQuery();
    return meData?.department || null;
};